export default "__VITE_ASSET__C4mp8LG0__"